import 'arrive';
import $ from 'jquery';

document.arrive('.wpcf7', {existing: true}, function(){
    const fields = this.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea');
    fields.forEach(function(el){
        const checkValue = () => {
            const value = $(el).val();
            const label = $(el).parent().parent(); // label > .wpcf7-form-control-wrap > this
            if (value || $(el).attr('readonly')) {
                label.addClass('has-value');
            } else {
                label.removeClass('has-value');
            }
        };

        $(el).on('keyup', checkValue);
        $(el).on('change', checkValue);
        $(el).on('paste', checkValue);
        $(el).on('cut', checkValue);
        checkValue();
    });
});